(() => {
  'use strict';
  function colorInfo(value, tags = []) {
    let text = value.toLowerCase().replace(/\s+/g, ' ').trim();
    const dial = /\s*\/\s*(blue|green|red|black|tan) dial$/i.exec(text);
    if (dial) text = text.slice(0, dial.index).trim();
    const compact = text.replace(/\s+/g, '').replace(/whitegold/g, 'white');
    const colors = {
      white: ['white', 0, ['white-gold']], silver: ['white', 0, ['white-gold']], red: ['red', 4, ['multi','two-tone']], pink: ['pink', 5, ['multi','two-tone']], blue: ['blue', 6, ['multi','two-tone']], clear: ['clear', 7, ['multi','two-tone']], gold: ['gold', 1, ['gold']], rosegold: ['rose', 2, ['rose-gold']], black: ['black', 3, ['black']],
      'white/gold': ['white-gold', 10, ['two-tone']], 'white/rosegold': ['white-rose', 11, ['two-tone']],
      'black/gold': ['black-gold', 12, ['two-tone']], 'black/white': ['black-white', 13, ['two-tone']]
    };
    let entry = colors[compact];
    if (!entry && /^(blue|green|red|black|tan) dial$/.test(text)) {
      const tone = text.split(' ')[0];
      entry = [tone, ['blue', 'black', 'green', 'red', 'tan'].indexOf(tone), tags.map(t => t.toLowerCase().replace(/\s+/g, '-')).filter(t => ['gold', 'white-gold', 'rose-gold', 'black', 'two-tone', 'multi'].includes(t))];
    }
    if (!entry) {
      if (/white gold|silver/.test(text)) entry = colors.white;
      else if (/rose gold/.test(text)) entry = colors.rosegold;
      else if (/gold/.test(text)) entry = colors.gold;
    }
    entry ||= ['white', 9, []];
    return { tone: entry[0] + (dial ? `-${dial[1]}` : ''), rank: entry[1], keys: entry[2] };
  }
  const dataCache = new WeakMap();
  function dataFor(item) {
    if (dataCache.has(item)) return dataCache.get(item);
    const script = item.querySelector('[data-astro-watch-variants]');
    if (!script) return null;
    try {
      const data = JSON.parse(script.textContent);
      data.variants.forEach((variant, index) => Object.assign(variant, colorInfo(variant.color, data.tags), { index }));
      data.variants.sort((a, b) => a.rank - b.rank || a.index - b.index);
      const colors = [...new Set(data.variants.map(variant => variant.color))];
      data.variants = colors.map(color => data.variants.find(variant => variant.color === color && variant.available) || data.variants.find(variant => variant.color === color));
      dataCache.set(item, data);
      return data;
    } catch (error) { console.error('Watch variant data could not be read', error); return null; }
  }
  function renderSwatches(item, data) {
    const info = item.querySelector('.m-product-card__info, .m-search-item--content');
    if (!info || item.querySelector('[data-astro-variant-swatches]')) return;
    const nav = document.createElement('nav');
    nav.className = 'astro-watch-swatches';
    nav.dataset.astroVariantSwatches = '';
    nav.setAttribute('aria-label', item.closest('[data-astro-choose-color]')?.dataset.astroChooseColor || 'Choose watch color');
    data.variants.slice(0, 3).forEach(variant => {
      const link = document.createElement('a');
      link.href = variant.url; link.title = variant.color;
      link.className = 'astro-watch-swatch'; link.dataset.astroVariantId = variant.id;
      link.setAttribute('aria-label', variant.color);
      const dot = document.createElement('span'); dot.className = `astro-watch-dot astro-watch-dot--${variant.tone}`; dot.setAttribute('aria-hidden', 'true');
      link.append(dot); nav.append(link);
    });

    if (data.variants.length > 3) {
      const more = document.createElement('a');
      more.href = `${data.url}#AstroWatchColors`;
      more.className = 'astro-watch-more';
      more.textContent = item.closest('[data-astro-more]')?.dataset.astroMore || '+ more';
      nav.append(more);
    }

    const price = info.querySelector('.m-product-card__price');
    if (price) price.after(nav); else if (info.closest('a')) info.closest('a').after(nav); else info.append(nav);
  }
  function applyColor(item, selectedColors, variantId) {
    const data = dataFor(item);
    if (!data) return null;
    const matched = data.variants.filter(v => !selectedColors.length || v.keys.some(key => selectedColors.includes(key)));
    renderSwatches(item, data);
    if (!matched.length) return false;
    const queryWords = (new URLSearchParams(location.search).get('q') || document.querySelector('[data-search-input]')?.value || '').toLowerCase().match(/[\p{L}\p{N}]+/gu) || [];
    const colorMatches = matched.filter(v => queryWords.some(word => v.color.toLowerCase().split(/[^\p{L}\p{N}]+/u).includes(word)));
    const chosen = matched.find(v => String(v.id) === String(variantId)) || colorMatches.find(v => v.available) || colorMatches[0] || (!selectedColors.length ? matched[0] : matched.find(v => v.available) || matched[0]);
    const card = item.querySelector('.m-product-card') || item;
    if (card.dataset.astroSelectedVariant === String(chosen.id)) return true;
    card.dataset.astroSelectedVariant = chosen.id;
    card.querySelectorAll('.m-product-card__main-image img,.m-product-card__second-image img,.m-search-item--image img').forEach(img => {
      const responsive = img.closest('responsive-image');
      if (responsive) responsive.src = chosen.image;
      img.src = chosen.image; img.removeAttribute('srcset'); img.alt = `${item.dataset.astroProductTitle} — ${chosen.color}`;
    });
    card.querySelectorAll('a.m-product-card__link,a.m-product-card__name,a.m\\:flex').forEach(a => a.href = chosen.url);
    card.querySelectorAll('.m-product-quickview-button').forEach(button => button.dataset.astroVariantId = chosen.id);
    card.querySelectorAll('input[name="id"]').forEach(input => input.value = chosen.id);
    const money = price => typeof window.formatMoney === 'function' ? window.formatMoney(price, window.MinimogSettings?.money_format) : new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(price / 100);
    card.querySelectorAll('.m-price-item--sale').forEach(el => el.innerHTML = money(chosen.price));
    card.querySelectorAll('.m-price-item--regular').forEach(el => el.innerHTML = money(chosen.compare > chosen.price ? chosen.compare : chosen.price));
    card.querySelectorAll('.m-price').forEach(el => { el.classList.toggle('m-price--on-sale', chosen.compare > chosen.price); el.classList.toggle('m-price--sold-out', !chosen.available); });
    card.querySelectorAll('[data-astro-variant-id].astro-watch-swatch').forEach(link => { const active = link.dataset.astroVariantId === String(chosen.id); link.classList.toggle('is-active', active); if (active) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current'); });
    return true;
  }
  function expandColors(items, selectedColors) {
    items.filter(item => !item.hidden).forEach(item => {
      const data = dataFor(item);
      if (!data) return;
      const variants = data.variants.filter(v => !selectedColors.length || v.keys.some(key => selectedColors.includes(key)));
      if (!variants.length) return;
      applyColor(item, selectedColors, variants[0].id);
      let previous = item;
      variants.slice(1).forEach(variant => {
        const copy = item.cloneNode(true);
        copy.dataset.astroColorCopy = '';
        copy.removeAttribute('data-astro-watch-group');
        const suffix = `-astro-color-${variant.id}`;
        const ids = new Map();
        copy.querySelectorAll('[id]').forEach(node => { ids.set(node.id, node.id + suffix); node.id += suffix; });
        copy.querySelectorAll('[for],[aria-labelledby],[aria-describedby],[aria-controls],[form]').forEach(node => {
          ['for', 'aria-labelledby', 'aria-describedby', 'aria-controls', 'form'].forEach(attr => {
            if (node.hasAttribute(attr)) node.setAttribute(attr, node.getAttribute(attr).split(' ').map(id => ids.get(id) || id).join(' '));
          });
        });
        applyColor(copy, selectedColors, variant.id);
        previous.after(copy);
        previous = copy;
      });
    });
  }
  function decorate(root = document) {
    root.querySelectorAll('[data-astro-color-value]').forEach(dot => dot.classList.add(`astro-watch-dot--${colorInfo(dot.dataset.astroColorValue).tone}`));
    root.querySelectorAll('[data-astro-native-watch] .astro-watch-colors__options').forEach(row => {
      const current = row.querySelector('input:checked');
      if (current && window.matchMedia('(max-width:749px)').matches) {
        const node = current.closest('.astro-watch-native-node');
        row.scrollLeft = Math.max(0, node.offsetLeft - (row.clientWidth - node.offsetWidth) / 2);
      }
    });
  }
  function init() {
    decorate();
    document.querySelectorAll('.m-product-item').forEach(item => {
      if (!item.hasAttribute('data-astro-color-copy') && dataFor(item)) applyColor(item, (new URLSearchParams(location.search).get('astro_colors') || '').split(',').filter(Boolean));
    });
    const refreshSearch = () => document.querySelectorAll('.m-search-item.m-product-item').forEach(item => { if(dataFor(item)) applyColor(item, []); });
    const observer = new MutationObserver(changes => {
      if (changes.some(change => [...change.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('.m-search-item') || node.querySelector?.('.m-search-item'))))) refreshSearch();
      for (const change of changes) for (const node of change.addedNodes) if (node.nodeType === 1 && (node.matches?.('[data-astro-native-watch]') || node.querySelector?.('[data-astro-native-watch]'))) decorate(node.parentElement || node);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  window.AstroWatchVariants = { applyColor, colorInfo, expandColors };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', () => decorate());
})();
